import React from 'react';
import { FaStar } from 'react-icons/fa';
import Carousel from './Carousel';

const References = ({ headline, subheadline, references, className }) => {
  const slides = references.map(reference => {
    return (
      <div className="flex flex-col justify-center items-center px-4 lg:w-2/3" key={reference.authorName}>
        <p className="mb-4 text-light-900 italic leading-tight text-center text-2xl lg:text-3xl">{reference.quote}</p>
        <div className="flex text-gold px-2 text-3xl mb-2">
          <FaStar />
          <FaStar />
          <FaStar />
          <FaStar />
          <FaStar />
        </div>
        <div className="font-bold text-gray-700">{reference.authorName}</div>
      </div>
    );
  });

  return (
    references && (
      <div className={`flex flex-col ${className}`}>
        {headline && <h2 className="text-center">{headline}</h2>}
        {subheadline && <div className="text-xl text-center text-gray-700 mb-8">{subheadline}</div>}
        <div className="pt-6">
          <Carousel slides={slides} />
        </div>
      </div>
    )
  );
};

export default References;
